import type { UserRole } from './role'
import type { Feature } from './user'
import type { UserProfile } from './user-profile'
import { getRootOrganizationId } from './user-profile'

export type FeatureFlagLevel = 'org' | 'user'

export interface FeatureFlagType {
  name: string
  level: FeatureFlagLevel
}

export function checkFeatureFlag(featureFlag: FeatureFlagType, profile: UserProfile, profileIsLoading: boolean) {
  if (profileIsLoading) {
    console.log('checkFeatureFlag: Profile is loading')
    return false
  }

  let isFeatureTrue = false
  if (featureFlag.level === 'org') {
    // get the root org for the user
    const rootOrg = getRootOrganizationId(profile)
    // find the role with the rootOrgId
    const role = profile.roles.find((role: UserRole) => role.organization.id === rootOrg)
    console.log('checkFeatureFlag: role', role)
    if (role) {
      isFeatureTrue =
        role.organizationFeatures?.some(
          (feature: Feature) => feature.name === featureFlag.name && feature.enabled === true
        ) ?? false
    }
  } else {
    isFeatureTrue =
      profile.features?.some((feature) => feature.name === featureFlag.name && feature.enabled === true) ?? false
  }
  return isFeatureTrue
}
